export default __webpack_public_path__ + "static/franchise-1-1b0547ccaf499f1cb097dc00d3e0795a.jpg";